import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { setLegalRepresentativeCreateRequestField, setLegalRepresentativeUpdateRequestField } from "../../../../pages/clienti/feature/legalRepresentative/slice";
import { MadfarmInput } from "../../input/newInput";

interface Props {
    mode: "create" | "edit"
}

export function RappLegaleContatti({ mode }: Props) {
    const legatRepresentativeState = useAppSelector(state => state.legalRapresentative)
    const dispatch = useAppDispatch()

    const legalRepresentativeRequest = mode === "create" ? legatRepresentativeState.legalRepresentativeCreateRequest : legatRepresentativeState.legalRepresentativeUpdateRequest

    return (
        <div className="flex flex-col gap-4">
            <div className="grid grid-cols-2 gap-4">
                <MadfarmInput
                    required
                    error={!!legatRepresentativeState.legalRepresentativeCreateErrors.phone}
                    supportingText={legatRepresentativeState.legalRepresentativeCreateErrors.phone}
                    label="Telefono"
                    placeholder="Telefono"
                    defaultValue={legalRepresentativeRequest.phone}
                    onChangeText={(text) => {
                        if (mode === "create")
                            dispatch(setLegalRepresentativeCreateRequestField({ field: "phone", value: text }))
                        else
                            dispatch(setLegalRepresentativeUpdateRequestField({ field: "phone", value: text }))
                    }}
                />
                <MadfarmInput
                    label="Cellulare"
                    placeholder="Cellulare"
                    error={!!legatRepresentativeState.legalRepresentativeCreateErrors.mobilePhone}
                    supportingText={legatRepresentativeState.legalRepresentativeCreateErrors.mobilePhone}
                    defaultValue={legalRepresentativeRequest.mobilePhone}
                    onChangeText={(text) => {
                        if (mode === "create")
                            dispatch(setLegalRepresentativeCreateRequestField({ field: "mobilePhone", value: text }))
                        else
                            dispatch(setLegalRepresentativeUpdateRequestField({ field: "mobilePhone", value: text }))
                    }}
                />
            </div>
            <div className="grid grid-cols-2 gap-4">
                <MadfarmInput
                    required
                    label="Email"
                    placeholder="Email"
                    defaultValue={legalRepresentativeRequest.email}
                    error={!!legatRepresentativeState.legalRepresentativeCreateErrors.email}
                    supportingText={legatRepresentativeState.legalRepresentativeCreateErrors.email}
                    onChangeText={(text) => {
                        if (mode === "create")
                            dispatch(setLegalRepresentativeCreateRequestField({ field: "email", value: text }))
                        else
                            dispatch(setLegalRepresentativeUpdateRequestField({ field: "email", value: text }))
                    }}
                />
                <MadfarmInput
                    label="Fax"
                    placeholder="Fax"
                    defaultValue={legalRepresentativeRequest.fax}
                    onChangeText={(text) => {
                        if (mode === "create")
                            dispatch(setLegalRepresentativeCreateRequestField({ field: "fax", value: text }))
                        else
                            dispatch(setLegalRepresentativeUpdateRequestField({ field: "fax", value: text }))
                    }}
                />
            </div>
        </div>
    )
}